import { styled } from "../../styled-components";

export const GalleryListContainer = styled.div<{ columns: number; rowHeight: number }>`
    display: grid;
    grid-template-columns: ${p => " minmax(10px, 1fr)".repeat(p.columns)};
    grid-template-rows: ${p => p.rowHeight}px;
    grid-column-gap: 1px;

    margin-bottom: 1px;
`;
